"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var translations = {
    passwodWasReset: {
        en: "Your password was reseted",
        es: "Tu contraseña se cambio correctamente",
    },
    login: {
        en: "Login",
        es: "Iniciar Sesión",
    },
    logout: {
        en: "Logout",
        es: "Cerrar Sesión",
    },
    loginPlaceholder: {
        en: "Username / Email",
        es: "Usuario / Correo Electrónico",
    },
    forgot: {
        en: "Forgot password",
        es: "Olvidaste tu Contraseña?",
    },
    remember: {
        en: "Remember me",
        es: "Recuérdame",
    },
    forgotYourPassword: {
        en: "Forgot your password?",
        es: "Olvidaste tu contraseña?",
    },
    resetYourPassword: {
        en: "Reset your password",
        es: "Restablecer su contraseña",
    },
    resetPassword: {
        en: "Change my password",
        es: "Cambiar mi contraseña",
    },
    resetPasswordEmailSent: {
        en: "An email has been sent to {email} with a link to reset your password",
        es: "Se ha envió un correo a {email} con un link restablecer su contraseña.",
    },
    passwordWasReset: {
        en: "Your password has been restored successfully.",
        es: "Tu contraseña se ha restablecido con éxito.",
    },
    resetEmail: {
        en: "Email",
        es: "Correo Electrónico",
    },
    usernameRequire: {
        en: "The username or email is required",
        es: "El usuario o correo electrónico es requerido",
    },
    emailRequire: {
        en: "Please check your email",
        es: "Por favor revise su Correo Electrónico",
    },
    passwordRequire: {
        en: "The password is required",
        es: "La contraseña es requerida",
    },
    passwordLength: {
        en: "Password must be at least 6 chars long.",
        es: "La contraseña no puede ser menor ha 6 caracteres",
    },
    loginFailed: {
        en: "The username or password do not match",
        es: "El nombre de usuario o contraseña no coinciden.",
    },
    logoutFailed: {
        en: "logoutFailed",
        es: "logoutFailed",
    },
    inactiveAccount: {
        en: "This username is not active.",
        es: "El usuario se encuentra desactivado.",
    },
    loginFailedEmailNotVerified: {
        aka: ["resetFailedEmailNotVerified"],
        en: "It seems that your user has not been verified, please check your email and click on the verification link.",
        es: "Parece que tu usuario no ha sido verificado, por favor revisa tu correo y da click en el link de verificación.",
    },
    welcomeMessage: {
        en: "Greetings {username}",
        es: "Bienvenido {username}",
    },
    goodEvening: {
        en: "Good evening, {name}",
        es: "Buenas noches, {name}",
    },
    goodAfternoon: {
        en: "Good afternoon, {name}",
        es: "Buenas tardes, {name}",
    },
    goodMorning: {
        en: "Good morning, {name}",
        es: "Buenos días, {name}",
    },
    welcomeSubtitle: {
        en: "Choose any option from the left menu.",
        es: "Escoge cualquiera de las opciones del menu de la izquierda.",
    },
    reset: {
        en: "Reset",
        es: "Restablecer",
    },
    emailNotFound: {
        en: "The mail was not found.",
        es: "El correo no se encontró.",
    },
    invalidToken: {
        en: "The token you are using is not valid.",
        es: "El token que estás utilizando no es válido.",
    },
    authorizationRequired: {
        en: "The token you are using is not valid.",
        es: "El token que estás utilizando no es válido.",
    },
    restorePasswordAuto: {
        en: "An email has been sent to your email with a link to reset your password",
        es: "Se ha envió un correo a tu correo con un link restablecer su contraseña.",
    },
};
exports.default = translations;
